import React, { useEffect, useState } from "react";
import styles from "./styles/generate-speech-button.module.scss";
import FilledButton from "@/components/common/filled-button";
import Loader from "@/components/common/loader";
import CoverTooltip from "@/components/pages/convert/components/cover-tooltip";
import { useStartTextToSpeech } from "@/components/pages/text-to-speech/hooks/use-start-text-to-speech";
import { useTextToSpeechContext } from "@/components/pages/text-to-speech/components/providers/text-to-speech-provider";

const GenerateSpeechButton = () => {
  const [textInput, setTextInput] = useState<string>("");
  const [voice, setVoice] = useState<string>("");
  const [language, setLanguage] = useState<string>("English");
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { startTextToSpeech } = useStartTextToSpeech();
  const { settings } = useTextToSpeechContext();

  useEffect(() => {
    setTextInput(settings.text);
    setVoice(settings.voice);
    setLanguage(settings.language);
  }, [settings.text, settings.voice, settings.language]);

  const handleTtmClick = async () => {
    setIsLoading(true);
    try {
      await startTextToSpeech({
        text: textInput,
        voice: voice,
        language: language,
      });
    } catch (error) {
      console.error("Generation error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const isActive =
      textInput !== undefined &&
      settings.text?.length !== 0 &&
      voice !== undefined &&
      settings.voice?.length !== 0;
    setIsActive(isActive);
  }, [textInput, settings.text, voice, settings.voice]);

  return (
    <div
      className={styles.wrapper}
      data-tooltip-id="ttsTooltip"
      data-tooltip-content="Please select voice and write text you want to transform in speech"
    >
      {isLoading ? (
        <Loader size={"48px"} />
      ) : (
        <>
          <FilledButton
            text={"Generate Speech"}
            onClick={handleTtmClick}
            textTransform={"uppercase"}
            backgroundColor={"#ff5722"}
            disabled={!isActive}
          />
          {!isActive && <CoverTooltip id="ttsTooltip" />}
        </>
      )}
    </div>
  );
};

export default GenerateSpeechButton;
